import { HasClassName } from '~/types/HasClassName';
import { SortDescIcon } from '../Icon/SortDescIcon';
import { SortAscIcon } from '../Icon/SortAscIcon';
import { Tooltip } from '../Tooltip/Tooltip';
import { HasStyle } from '~/types/HasStyle';
import { PropsWithChildren } from 'react';
import styles from './Table.module.css';
import classNames from 'classnames';
import { HelpIcon } from '../Icon/HelpIcon';

type Props = PropsWithChildren &
  HasClassName &
  HasStyle & {
    sort?: 'asc' | 'desc';
    onClick?: () => void;
    colSpan?: number;
    as?: 'th' | 'td';
    align?: 'left' | 'right';
    tooltip?: string;
  };

export function Col({ children, sort, onClick, tooltip, as: Component = 'td', align = 'left', ...rest }: Props) {
  return (
    <Component
      className={classNames({
        [styles.right]: align === 'right',
        [styles.sortable]: !!onClick,
      })}
      onClick={onClick}
      {...rest}
    >
      <div className={styles.inner}>
        {children}

        {tooltip && (
          <Tooltip title={tooltip} className={styles.help}>
            <HelpIcon />
          </Tooltip>
        )}

        {sort === 'desc' && <SortDescIcon className={styles.sort} />}
        {sort === 'asc' && <SortAscIcon className={styles.sort} />}
      </div>
    </Component>
  );
}
